import { productCenterApi } from 'api';

export const getUnitServiceContractsQuery = (unitId: number) => ({
	queryKey: serviceContractKeys.unit(unitId),
	queryFn: async () =>
		(await productCenterApi.getAllServiceContracts(unitId)).data,
});

export const getServiceContractQuery = (id: string) => ({
	queryKey: serviceContractKeys.single(id),
	queryFn: async () =>
		(await productCenterApi.getServiceContractInfo(id)).data,
});

export const serviceContractKeys = {
	all: ['serviceContract'] as const,
	unit: (unitId: number) =>
		[...serviceContractKeys.all, unitId, 'unit'] as const,
	single: (id: string) => [...serviceContractKeys.all, id] as const,
};
